import { formatNumber, formatPercentage } from '@witmetrics/utils/strings';
import { blankArray, sortNumerical } from '@witmetrics/utils/arrays';
import { SCALES } from '../constants';

export const classes = {
  wrapper:
    'absolute top-0 left-1/2 -translate-x-1/2 flex grow-0 shrink-0 z-10 p-4',
  card: 'place-center h-14 w-full shadow-dialog bg-transparent hover:bg-white/40 dark:hover:bg-white/[0.1] bg-gradient-to-br from-white to-blue-200/40 dark:bg-none dark:bg-white/[0.06] backdrop-blur-sm border border-grey-3/80 dark:border-white/10 transition-colors duration-500 hover:duration-100',
  controlWrapper:
    'flex items-center px-3 md:px-4 text-grey-9 dark:text-mauve-1 gap-1',
  dropdown: 'w-28',
  menu: 'max-h-60 overflow-auto',
};

export function buildScaleOption(scale: number) {
  return {
    label: formatPercentage(scale, 0),
    value: scale,
  };
}

export function buildPageLabel(page: number, pageCount: number) {
  return `${formatNumber(page)} / ${formatNumber(pageCount)}`;
}

export function buildPageOptions(pageCount: number) {
  return blankArray(pageCount).map((_, i) => ({
    label: `Page ${formatNumber(i + 1)}`,
    value: i + 1,
  }));
}

export function getIncrementedScale(currentScale: number, increment: 1 | -1) {
  let scale: number | undefined;
  if (increment === 1) {
    scale = sortNumerical(SCALES).find((s) => s > currentScale);
  } else if (increment === -1) {
    scale = sortNumerical(SCALES, -1).find((s) => s < currentScale);
  }
  if (scale === undefined) {
    return increment === -1 ? SCALES[0] : SCALES[SCALES.length - 1];
  } else return scale;
}
